module.exports = __webpack_public_path__ + "img/voltaje_c_blue.405fb0a5.svg";